import React, { useEffect, useState } from "react";
import { Container, Form, Button, Row, Col, Modal } from "react-bootstrap";
import Header from "./Header";
import { Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import "./Layout.css";

const Layout = () => {
  const location = useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location.pathname]);

  return (
    <div>
      <Header />
      <div className="layout">
        <div style={{ paddingTop: "12vh", minHeight: "100vh" }}>
          {/* Your routed content */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
